import { type ProgramCompletion } from '@terros/common'
import { type SelectItem } from '../types'

export const DEFAULT_PROGRAM_DURATIONS = [30, 60, 90, 120]
export const PROGRAM_DURATION_OPTIONS: SelectItem[] = [
  ...DEFAULT_PROGRAM_DURATIONS.map((d) => ({ value: d.toString(), label: `${d} days` })),
  { value: 'custom', label: 'Custom' },
]

export const PROGRAM_COMPLETION_OPTIONS: SelectItem<ProgramCompletion>[] = [
  {
    value: 'timeline',
    label: 'Tasks will be assigned on a timeline, and the program will be completed after the total days',
  },
  {
    value: 'taskCompletion',
    label: 'Tasks will be assigned all at once, and the program will be completed when all tasks are completed',
  },
]
